module.exports = __webpack_public_path__ + "static/31-fc9511b06ddaf65c7be7b040b58b4aed.jpg";